export default __webpack_public_path__ + "static/media/full-vertical-divider.386b7e50.svg";